import { render, staticRenderFns } from "./TaxWarrantsCreateDialog.vue?vue&type=template&id=f0b2034a&scoped=true&"
import script from "./TaxWarrantsCreateDialog.vue?vue&type=script&lang=js&"
export * from "./TaxWarrantsCreateDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaxWarrantsCreateDialog.vue?vue&type=style&index=0&id=f0b2034a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b2034a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
